import { getToken, identityHeaders, login } from './session';

let onUnavailable: () => void = () => {};

export function bindUnavailable(handler: () => void): void {
  onUnavailable = handler;
}

export async function authHeaders(): Promise<Record<string, string>> {
  const headers: Record<string, string> = { ...identityHeaders() };
  const token = await getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  const tenantId = localStorage.getItem('orqforge.tenantId');
  if (tenantId) headers['x-tenant-id'] = tenantId;
  const workspaceId = localStorage.getItem('orqforge.workspaceId');
  if (workspaceId) headers['x-workspace-id'] = workspaceId;
  return headers;
}

export async function handleApiStatus(res: Response): Promise<void> {
  if (res.status === 401) login();
  if (res.status === 503) onUnavailable();
  if (!res.ok) {
    const text = await res.clone().text();
    throw new Error(text || `${res.status} ${res.statusText}`);
  }
}

export async function checkHealth(): Promise<boolean> {
  try {
    const res = await fetch('/api/health', { signal: AbortSignal.timeout(8000) });
    return res.ok;
  } catch {
    return false;
  }
}
